
export default class Deferred {

  constructor () {
    this.promise = new Promise((res, rej) => {
      this.resolve = res;
      this.reject = rej;
    });
  }

  // addDeferredLock :: (Object, Options) -> String -> void
  //  Options = {
  //      deferred: String,
  //      lock: String
  //  }
  static addLock (obj, options = {}) {
    const {
      deferred = 'deferred',
      lock = 'lock'
    } = options;

    return name => {
      const d = new Deferred();
      obj[deferred] = Object.assign({}, obj[deferred], { [name]: d });
      obj[lock] = Object.assign({}, obj[lock], { [name]: d.promise });
    };
  }

}

// addDeferredLock :: (String, Object, Options) -> void
//  Options = { propDeferred: String, propLock: String }
// export function addLock (name, obj, options = {}) {
//   const {
//     propDeferred = 'deferred',
//     propLock = 'lock'
//   } = options;
//   const d = new Deferred();
//   this[propDeferred] = Object.assign({}, this[propDeferred], { [name]: d });
//   this[propLock] = Object.assign({}, this[propLock], { [name]: d.promise });
// }
